// Consent to clinic broadcast emails, as the patient sees and gives it.
//
// The server records every change in a consent ledger and refuses a "yes" to
// promotions that does not name the wording the patient agreed to
// (blhWebServer/src/domain/consents/communicationConsent.js). Change the wording
// below and the version together, in both repositories.

export const PROMOTION_DISCLOSURE_VERSION = "2026-09-15";

export const PROMOTION_DISCLOSURE =
  "By turning this on, you agree to receive occasional news and offers from your clinic by email. You can unsubscribe at any time from any of these emails or here. Appointment reminders and messages about your care are not affected.";

export const ANNOUNCEMENT_DESCRIPTION =
  "Updates from your clinic that affect your care, such as closures, new hours or policy changes. Appointment reminders are not affected.";
